var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.621,
    height: 19.738,
    viewBox: "0 0 16.621 19.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-profile",
    transform: "translate(-1.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_612",
    "data-name": "\\uD328\\uC2A4 612",
    d: "M18.18,19.738h-2A6.223,6.223,0,0,0,9.869,13.62a6.223,6.223,0,0,0-6.31,6.118h-2A8.225,8.225,0,0,1,9.87,11.62,8.225,8.225,0,0,1,18.18,19.738Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_613",
    "data-name": "\\uD328\\uC2A4 613",
    d: "M9.87,10.97a5.485,5.485,0,1,1,5.486-5.485A5.492,5.492,0,0,1,9.87,10.97ZM9.87,2a3.485,3.485,0,1,0,3.486,3.485A3.488,3.488,0,0,0,9.87,2Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUser2);
export default __webpack_public_path__ + "static/media/ico_user2.1e78e5ef970fb085e3dbeb73b6ccf341.svg";
export { ForwardRef as ReactComponent };